// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Commands
// MODIFIED DATE : 07-08-2025

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';
/** ***************** CREATE CENTER WISE LOAN PROPOSAL START *********************** */
export const createNewCenterWiseLoan = (addData: any) => {
	const data = {
		createLoanIndexBranchToken: addData,
	};
	const url = `${API_URL}addLoanIndexForBranch`;
	return makeApiCall(url, data);
};
/** ***************** CREATE CENTER WISE LOAN PROPOSAL END *********************** */

/** ***************** UPDATE CENTER WISE LOAN PROPOSAL START *********************** */
export const updateCenterWiseLoan = (updateData: any) => {
	const data = {
		CenterWiseLoanProposalUpdateToken: updateData,
	};
	const url = `${API_URL}updateCenterWiseLoanProposal`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE CENTER WISE LOAN PROPOSAL END *********************** */

/** ***************** FETCH MEMBERS LIST FOR CENTER WISE LOAN START *********************** */
export const fetchMembersListForCenterLoan = (deleteData: any) => {
	const data = {
		GetCenterWiseMembersListToken: deleteData,
	};
	const url = `${API_URL}getMemberDetailsForCenterWise`;
	return makeApiCall(url, data);
};
/** ***************** FETCH MEMBERS LIST FOR CENTER WISE LOAN END *********************** */

/** ***************** FETCH MEMBERS LIST FOR CENTER WISE LOAN START *********************** */
export const centerWiseLoanProposalDetailsFetch = (fetchData: any) => {
	const data = {
		getParticularBranchLoanIndexInfoToken: fetchData,
	};
	const url = `${API_URL}getParticularBranchLoanIndexList`;
	return makeApiCall(url, data);
};
/** ***************** FETCH MEMBERS LIST FOR CENTER WISE LOAN END *********************** */

/** ***************** ADD MEMBER BANK DETAILS START *********************** */
export const memberBankDetailsAdd = (fetchData: any) => {
	const data = {
		CreateMemberBankDetailsDataToken: fetchData,
	};
	const url = `${API_URL}createMemberBankDetails`;
	return makeApiCall(url, data);
};
/** ***************** ADD MEMBER BANK DETAILS END *********************** */

/** ***************** GET MEMBER BANK DETAILS START *********************** */
export const memberBankDetailsFetch = (fetchData: any) => {
	const data = {
		MemberBankDetailsToken: fetchData,
	};
	const url = `${API_URL}getMemberBankDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET MEMBER BANK DETAILS END *********************** */

/** ***************** UPDATE CORRECT LOAN START/END DATE FOR MEMBER START *********************** */
export const correctLoanStartEndDateForMemberUpdate = (updateData: any) => {
	const data = {
		UpdateCorrectLoanStartEndDateForMemberToken: updateData,
	};
	const url = `${API_URL}updateCorrectLoanStartEndDateForMember`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE CORRECT LOAN START/END DATE FOR MEMBER END *********************** */

/** ***************** UPDATE CORRECT LOAN FOR OVERALL MEMBER START *********************** */
export const correctLoanForOverallMemberUpdate = (updateData: any) => {
	const data = {
		CorrectLoanForOverAllMemberToken: updateData,
	};
	const url = `${API_URL}updateCorrectLoanForOverAllMember`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE CORRECT LOAN FOR OVERALL MEMBER END *********************** */
